/**
 * Utilitaire pour gérer les headers HTTP avec la langue
 */

/**
 * Récupère la langue courante depuis le localStorage
 * @returns {string} Code langue (fr, es, en) - fallback sur 'en'
 */
export const getCurrentLanguage = () => {
  const savedLang = localStorage.getItem('preferredLanguage');
  const validLanguages = ['fr', 'es', 'en'];
  
  // Vérifier que la langue sauvegardée est valide
  if (savedLang && validLanguages.includes(savedLang)) {
    return savedLang;
  }
  
  // Fallback sur 'en'
  return 'en';
};

/**
 * Crée les headers HTTP standard avec la langue
 * @param {string} language - Code langue (optionnel, sinon récupéré depuis localStorage)
 * @param {Object} additionalHeaders - Headers additionnels à inclure
 * @returns {Object} Headers complets avec Accept-Language
 */
export const createApiHeaders = (language = null, additionalHeaders = {}) => {
  const lang = language || getCurrentLanguage();
  
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': lang,
    ...additionalHeaders
  };
};

/**
 * Crée les headers HTTP pour l'API WMB
 * @param {string} apiKey - Clé API WMB
 * @param {string} language - Code langue (optionnel)
 * @returns {Object} Headers avec langue et clé API
 */
export const createWmbApiHeaders = (apiKey, language = null) => {
  return createApiHeaders(language, {
    'x-api-key': apiKey
  });
};
